function externalLinks() {
	$.expr[':'].external = function(obj){
		return !obj.href.match(/^mailto\:/)
			&& (obj.hostname !== location.hostname)
			&& !obj.href.match(/^javascript\:/)
			&& !obj.href.match(/^$/)
	};
	$('a:external').attr('target', '_blank');
}

MoyaContainer.register('site.tubeChannel', function() {
	return {
		init() {
			document.querySelectorAll('.box_tubechannel:not(.videoInit)').forEach(function (box) {
				const id = 'youTubeVideo' + box.getAttribute('id').match(/\d+/)[0];
				const player = box.querySelector('.videoPlayer');
				player.setAttribute('id', id);
				youtubePlayers[id] = new YT.Player(id, {
					"height": "562",
					"width": "1000",
					"videoId": player.getAttribute('data-video'),
					"playerVars": {
						"loop": 0,
						"hl": player.getAttribute('data-lang'),
						"cc_load_policy": 0,
						"autoplay": 0,
						"iv_load_policy": 3,
						"fs": 1,
						"controls": 1,
						"rel": 0,
						"disablekb": 0
					}
				});

				box.querySelectorAll('button.video').forEach(function (thumb) {
					thumb.addEventListener('click', () => {
						youtubePlayers[id].loadVideoById(thumb.getAttribute('data-video'));
						box.querySelector('.video_title').innerHTML = thumb.querySelector('.title').innerHTML;
						box.querySelector('.video_desc').innerHTML = thumb.querySelector('.desc').innerHTML;
					})
				});

				box.classList.add('videoInit');
			});
		}
	}
});

const tubeChannel = MoyaContainer.get('site.tubeChannel');
let youtubePlayers = [];

window.onYouTubeIframeAPIReady = function () {
	tubeChannel.init();
};

let isScrolling = false;
const util = MoyaContainer.get('core.util');
MoyaComponents.register('site.onepager', [

], (el) => {
	let hasScrolled = false;
	const setHasScrolled = () => {
		hasScrolled = true;
		window.removeEventListener('scroll', setHasScrolled);
	}
	window.addEventListener('scroll', setHasScrolled);

	const sectionOffset = 150;
	inView('section.subpage').on('enter', section => {
		if (!section.classList.contains('loaded')) {
			section.classList.add('loading');
			$.ajax({
				url: section.getAttribute('data-url'),
				success: function (data) {
					const wrappedData = '<!--googleoff: index--> ' + data + '<!--googleon: index>'
					$('> .boxText', section).append(wrappedData);
					section.classList.remove('loading');
					section.classList.add('loaded');

					setTimeout(() => {
						site.boxes.init();
					}, 400);

					titleAnchorInView();
					tubeChannel.init();
				}
			});

			//Go to correct href in case of scrolled too much after setion load
			if (window.location.hash) {
				window.location = window.location.href;
			}
		}

		const sectionScrollHandler = () => {
			if (section.getBoundingClientRect().top <= sectionOffset) {
				doSectionSubpageEnter(section);
				window.removeEventListener('scroll', sectionScrollHandler);
			}
		}
		if (section.getBoundingClientRect().top > sectionOffset) {
			window.addEventListener('scroll', sectionScrollHandler);
		}
		else {
			doSectionSubpageEnter(section);
		}
	});

	const doSectionSubpageEnter = (section) => {
		let codename = section.getAttribute('id');
		let baseUrl = document.querySelector('.sidebar__menu').getAttribute('data-base-url');
		window.history.replaceState({}, '', baseUrl + codename);
		let sidebarItem = document.querySelector('.sidebar__menu .level3[data-codename="' + codename + '"]');
		document.querySelectorAll('.sidebar__menu .level3.down').forEach(li => {
			li.classList.remove('down', 'selectedLevel3');
		});
		if (hasScrolled) {
			sidebarItem.classList.add('down', 'selectedLevel3');
			setDocumentTitle(sidebarItem.querySelector('a').innerText);
		}
	}

	inView('.page__content__main').on('enter', () => {
		if (!hasScrolled) {
			//Redirect old anchor url
			let hash = window.location.hash.substring(1);
			if (hash) {
				let sidebarItem = document.querySelector('.sidebar__menu li[data-codename="' + hash + '"] > a');
				if (sidebarItem) {
					sidebarItem.click();
				}
			}
		}
		else {
			//Remove hash from url and close sidebar when scrolled back to top
			let baseUrl = document.querySelector('.sidebar__menu').getAttribute('data-base-url');
			window.history.replaceState( {} , '', baseUrl);
			document.querySelectorAll('.sidebar__menu .level3.down').forEach(li => {
				li.classList.remove('down', 'selectedLevel3');
			});
			setDocumentTitle(document.querySelector('.currentSitemapNode').innerText);
		}
	});

	titleAnchorInView();

	util.delegate(el, 'click', '.toggler', (toggler) => {
		toggler.target.parentNode.classList.toggle('down');
		if (toggler.target.parentNode.classList.contains('down')){
			toggler.target.parentNode.classList.add('parentClicked');
		} else {
			toggler.target.parentNode.classList.remove('parentClicked');
		}
	});

	util.delegate(el, 'click', '.level4 > a', (e) => {
		document.querySelectorAll('.sidebar__menu .level4.active').forEach(li => {
			li.classList.remove('active');
		});
		e.target.closest('li').classList.add('active', 'clicked');
		isScrolling = true;
		setTimeout(() => {
			e.target.closest('li').classList.remove('clicked');
			isScrolling = false;
		}, 1000);
	});

});

function setDocumentTitle(title) {
	let titleParts = top.document.title.split('|');
	top.document.title = title + ' | ' + titleParts.pop();
}

const anchorOffset = 240;
const titleAnchorInView = () => {
	inView('main .titleAnchor').on('enter', anchor => {
		const scrollHandler = () => {
			if (anchor.parentElement.getBoundingClientRect().top <= anchorOffset) {
				doTitleAnchorInView(anchor);
				window.removeEventListener('scroll', scrollHandler);
			}
		}
		if (anchor.parentElement.getBoundingClientRect().top > anchorOffset) {
			window.addEventListener('scroll', scrollHandler);
		}
		else {
			doTitleAnchorInView(anchor);
		}
	});
}

const doTitleAnchorInView = (anchor) => {
	if (isScrolling) {
		return false;
	}
	let codename = anchor.getAttribute('id');
	let sidebarItem = document.querySelector('.sidebar__menu .level4[data-codename="' + codename + '"]');

	if (sidebarItem) {
		let parent = sidebarItem.closest('.level3');
		let parentTitle = '';
		if (parent) {
			document.querySelectorAll('.sidebar__menu .level3.down').forEach(li => {
				li.classList.remove('down', 'selectedLevel3');
			});
			parent.classList.add('down', 'selectedLevel3');
			parentTitle = parent.querySelector('a').innerText;
		}
		if (!sidebarItem.classList.contains('clicked')) {
			document.querySelectorAll('.sidebar__menu .level4.active').forEach(li => {
				li.classList.remove('active');
			});
			sidebarItem.classList.add('active');
			let a = sidebarItem.querySelector('a[href*="' + codename + '"]');
			if (a) {
				window.history.replaceState({}, '', a.getAttribute('href'));
			} else {
				window.history.replaceState({}, '', '#' + codename);
			}
			if (parentTitle) {
				setDocumentTitle(parentTitle);
			}
		}
	}
}

if (document.querySelector('body').classList.contains('boxes')) {
	const prevLink = document.querySelector('.prev__link');
	if (prevLink) {
		document.getElementsByTagName('body')[0].onscroll = () => {
			if (window.scrollY === 0 && !prevLink.classList.contains('show')) {
				prevLink.classList.add('show');
			}
		};
	}
}

var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
	lastScrollTop: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		var $body = $('body');
		$('.mmLevel2, .menuText').each(function() {
			var $height = $(this)[0].scrollHeight;
			$(this).css('max-height', $height);
		});

		var $tapElements = $('.front__left, .front__right');

		if ($body.width() <= 992 && !site.device.isTouch()) {
			var $hoverElements = $('main, .front__left, .front__right');
			$hoverElements.on('mouseenter', function() {
				$(this).addClass('hover');
			});
			$hoverElements.on('mouseleave', function() {
				$(this).removeClass('hover');
			});
		}

		if (site.device.isTouch()) {
			$body.addClass('isTouch');
			$('.front__logo').on('click', () => {
				$('main').removeClass('hover');
				$tapElements.removeClass('hover');
			})
		}

		$tapElements.on('click', function() {
			$('main').addClass('hover');
			$tapElements.removeClass('hover');
			$(this).addClass('hover');
		});
	},

	beacon: function() {
		var $beacon = localStorage.getItem('beacon');
		if (!$beacon) {
			$beacon = 1;
		}
		$beacon = parseInt($beacon);
		if ($beacon < 3) {
			$('body').addClass('beacon');
		}
		$('.beacon__button .btn').on('click', function(e) {
			$beacon++;
			localStorage.setItem('beacon', $beacon.toString());
			$('body').removeClass('beacon');
		})
		$('.beacon__overlay').on('click', function(e) {
			$('body').removeClass('beacon');
		})
	}
};


site.boxes = {
	init: function() {
		$('.box:not(.init)').each(function() {
			var $this = $(this);
			$this.addClass('init');

			if ($this.hasClass('box_tiny')) {
				$("ul > li a[href$='.pdf']", $this).each(function () {
					$(this).closest('li').addClass('pdf');
				});

				$("ul > li a[href^='http']", $this).each(function () {
					$(this).closest('li').addClass('http');
				});
			}

			if ($this.hasClass('readMore')) {
				var $readMore = $('.boxText', $this);
				$readMore.each(function () {
					$(this).css('max-height', $(this)[0].scrollHeight);
					$(window).resize(function () {
						$(this).css('max-height', $(this)[0].scrollHeight);
					})
				});

				var $readMoreBtns = $readMore.find('.readMoreBtn');
				$readMoreBtns.each(function () {
					$(this).on('click', function () {
						$(this).closest('.box').addClass('hasExpanded');
					});
				});
			}

			$('.tube__channel .video', $this).click(function () {
				var currentVideoClass = $(this).attr('class').split(' ')[1]
				$('.video-infos .video-info').each(function () {
					if($(this).hasClass(currentVideoClass)) {
						$(this).addClass('active');
					}
					else {
						$(this).removeClass('active');
					}
				});
			});

			$('.bullet__list > li, .ordered__list > li', $this).each(function() {
				$(this).wrapInner(function() {
					return '<div></div>';
				})
			});

			var $masonry = $('.bullet__list--masonry', $this);
			$masonry.find('li').addClass('grid-item');
			$('<li class="grid-sizer"></li>').prependTo($masonry);
			$masonry.masonry({
				columnWidth: '.grid-sizer',
				itemSelector: '.grid-item',
				gutter: 40
			});
			externalLinks()
		});

		//Accordion
		var $accordions = $('section.accordion');
		$accordions.each(function () {
			var $this = $(this);
			if ($this.find('.wrap').length) {
				return;
			}
			site.accordion.initMaxHeight();
			$('>*:not(:first-child)', $this).wrapAll('<div class="wrap" />');
			$('>:first-child', $this).contents().eq(0).wrap('<a href="#">');
			$this.addClass('ready');
		});

		$('img.responsive').responsiveImg({threshold: $(document).height()});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.boxes.init();

	if ($('aside').length) {
		$('img.responsive').responsiveImg({threshold: $(document).height()});
	}

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
		site.frontpage.beacon();
	}

	$('.page__abending__close').click(function () {
		$('.page__abending').removeClass('slide-in-blurred-bottom');
		$('.page__abending').addClass('slide-out-blurred-bottom');
		if(window.innerWidth < 768) {
			$('.page__abending').addClass('show');
		}
	});
	$('.page__abending__opener').click(function () {
		$button = $(this);
		$('.page__abending').removeClass('slide-out-blurred-bottom hide');
		$('.page__abending').addClass('slide-in-blurred-top');
		if(window.innerWidth < 768) {
			$('.page__abending').addClass('show');
		}
		$button.addClass('slide-out-blurred-bottom');
		setTimeout(function(){
			$button.addClass('hide');
			$button.removeClass('slide-out-blurred-bottom');
			$('.page__abending').removeClass('slide-in-blurred-top');
		}, 750);

	});

	setTimeout(function(){
		$('.page__abending').addClass('slide-in-blurred-bottom');
		$('.page__abending').removeClass('hide');
	}, 750);


	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	externalLinks();

	// Fix external links to anchor
	let urlHash = window.location.hash;

	if (urlHash) {
		window.location.hash = '';
		setTimeout(() => {
			window.location.hash = urlHash;
		}, 1000)
	}
});
